import { Container } from 'semantic-ui-react';

export default Container;
